import { render, staticRenderFns } from "./MediaThumb.vue?vue&type=template&id=613c39bc&scoped=true"
import script from "./MediaThumb.vue?vue&type=script&lang=js"
export * from "./MediaThumb.vue?vue&type=script&lang=js"
import style0 from "./MediaThumb.vue?vue&type=style&index=0&id=613c39bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613c39bc",
  null
  
)

export default component.exports